import { Canvas, UIImage, UIText } from "./canvas";
import Game, { BallType, PlayState, Events } from "./game";
import { OutcomeName } from "./delivery";
import App from "../main";
import { SDKManager } from "./SDKManager";
import ObjectiveScene from "./objective-scene";
import MenuScene from "./menu-scene";
import { GAME_STATE } from "./Enums";
import { RIGHT } from "phaser";

export { };

const gamesnacks = window.GameSnacks;

export default class InGameHUD extends Canvas {

    public static instance: InGameHUD;
    private gameover: boolean = false;
    public static inputEnabled: boolean = true;
    public static inputType: string = "";
    public canShowPausePanel = false;

    private screenInput: any;
    constructor() {
        super({
            key: 'InGameHUD'
        });
    }
    private cursors: any;

    preload() {
        InGameHUD.instance = this;
        // window.gameEvents = this.game.events;
        // window.GameSnacks.Events = Events;
        window.addEventListener(Events.OnMute, this.muteAudio.bind(this));
        // ObjectiveScene.instance.wakeUpWebAudioApi();
        this.cursors = this.input.keyboard.addKeys({
            right: Phaser.Input.Keyboard.KeyCodes.RIGHT,
            left: Phaser.Input.Keyboard.KeyCodes.LEFT
        });
        let loadingScreen = document.getElementById('loading-screen');
        let loaderText = document.getElementById('loader-text');
        let loaderBar = document.getElementById('loader-bar');

        let item = document.getElementById('item');

        loadingScreen.classList.remove('hide');

        this.load.on('progress', function (value) {
            let percent = Math.floor((value * 100)) + "%"
            loaderBar.style.width = percent;
            loaderText.innerText = percent
        });

        this.load.on('fileprogress', function (file) {
            item.innerText = "Loading";//file.src;

        });

        this.load.on('complete', function () {
            loadingScreen.classList.add('hide');
        });

        this.load.json('ingameCanvas', 'ui/ingame-canvas.json');

        SDKManager.onGamePause(this.onGamePause.bind(this));
        SDKManager.onGameResume(this.onGameResume.bind(this));

        const onVisibilityChange = () => {
            if (document.hidden) {
                // if (SDKManager.gameState != PlayState.SetBowler && !this.gameover) {
                if (!this.game.isTutorial && this.canShowPausePanel) {
                    this.game.events.emit('onPauseButton');
                    this.bowlerPanel.hidePanel();
                    this.hideControls();
                    this.pausePanel.showPanel();
                }
            }
        }
        document.addEventListener("visibilitychange", onVisibilityChange);
    }

    onGamePause() {
        App.isMute = this.game.sound.mute = true;
        this.game.events.emit('onPauseButton');
        this.scene.pause()
        console.log("Game Pause on ingame-hud")

    }
    onGameResume() {
        this.checkAudioAfterAd();
        this.game.events.emit('onResumeButton');
        this.scene.resume();
        console.log("Game Resume")
    }
    public checkAudioAfterAd() {
        let isAudioEnabled: boolean = true;
        if (SDKManager.local) {
            isAudioEnabled = true;
        }
        else {
            isAudioEnabled = gamesnacks.audio.isEnabled();
        }
        if (isAudioEnabled) {
            App.isMute = this.game.sound.mute = false;
            ObjectiveScene.instance.wakeUpWebAudioApi();
        }
        else {
            App.isMute = this.game.sound.mute = true;
        }
    }

    create() {
        // Verify it worked
        console.log('window.gameEvents:', window['gameEvents']);
        console.log('window.Events:', window['Events']);

        console.log('Try: window.gameEvents.emit(window.Events.OnMute)');

        this.checkAudioAfterAd();
        super.setCanvas('ingameCanvas');
        this.consoleText = this.children.getByName('ConsoleText') as UIText;
        this.initCurrentBowlerPanel();
        this.initControls();
        this.initBowlerPanel();
        this.initTimerPanel();
        this.initEndPanel();
        this.initPausePanel();
        this.initScoreBoard();
        this.initTutorialPanel();
        this.initWatchAdPanel();


        this.tutorialPanel.hidePanel();
        this.hideControls();
        this.timerPanel.hidePanel();
        this.bowlerPanel.resetOver();
        this.endPanel.hidePanel();
        this.pausePanel.hidePanel();
        this.scoreBoard.hidePanel();
        this.currentBowlerPanel.hidePanel();
        this.watchAdPanel.hidePanel();

        this.game.events.on(Events.OnPlayStateChanged, this.onPlayStateChanged.bind(this));
        this.game.events.on(Events.OnBowlerTypeChanged, this.onBowlerType.bind(this));
        this.game.events.on(Events.OnOutcomeChanged, this.onOutcome.bind(this));
        this.game.events.on(Events.OnRunsChanged, this.onRunsChanged.bind(this));
        //this.game.events.on(Events.OnOversChanged, this.onOversChanged.bind(this));
        this.game.events.on(Events.OnDurationChanged, this.onDurationChanged.bind(this));
        this.game.events.on(Events.OnWicketsChanged, this.onWicketsChanged.bind(this));
        this.game.events.on(Events.OnGameOver, this.onGameOver.bind(this));
        this.game.events.on(Events.OnTutorialMode, this.onTutorialMode.bind(this))
        this.game.events.on(Events.OnTotalOversChanged, ((totalOvers: number) => { this.totalOvers = totalOvers; }).bind(this));
        this.game.events.on(Events.OnAdAvailable, this.onAdAvailable.bind(this));
        this.game.events.on(Events.OnAdWatched, this.onAdWatched.bind(this));
        this.game.events.on(Events.OnConsoleText, this.onConsoleTextChanged.bind(this));




        this.events.on('wake', this.onAwake.bind(this));
        this.events.on('sleep', this.onSleep.bind(this));
    }

    onSleep() {
        this.game.events.off(Events.OnRunsChanged);
        this.game.events.off(Events.OnGameOver);
    }

    private consoleText: UIText;

    private onConsoleTextChanged(text: string) {
        //this.consoleText.text += '\n' + text;
        //this.consoleText.text = '';
        // //console.log(text);
    }

    private muteAudio() {
        console.log("Audio mute");
    }

    private onAdAvailable() {
        this.bowlerPanel.hidePanel();
        this.hideControls();
        setTimeout(() => {
            // //console.log('Ads available')
            this.watchAdPanel.showPanel();
        }, 1500);
    }

    private onAdWatched(hasWatched: boolean) {
        if (hasWatched) {
            //this.onConsoleTextChanged ('Watched ad show bowler panel');
            this.bowlerPanel.showPanel();
        }
    }

    private tutorialIndex: number = 0;
    private onTutorialMode(title: string) {
        // console.log("TUTORIAL", this.game.isTutorial);
        // console.log(`tutorial index: ${this.tutorialIndex}`);
        if (this.tutorialIndex == 0) {
            this.tutorialPanel.showPanel(false, 'HOW TO PLAY', 'PRESS THE RIGHT ARROW FOR OFFSIDE');
            this.bowlerPanel.hidePanel();
            InGameHUD.inputType = "RIGHT";
            InGameHUD.inputEnabled = true;
            this.leftArrow.visible = false;
            this.rightArrow.visible = true;


        } else if (this.tutorialIndex == 1) {
            //console.log(`tutorial index: ${this.tutorialIndex}`);
            this.tutorialPanel.showPanel(false, 'HOW TO PLAY', 'PRESS THE LEFT ARROW FOR LEGSIDE');
            this.bowlerPanel.hidePanel();
            InGameHUD.inputType = "LEFT";

            InGameHUD.inputEnabled = true;
            this.leftArrow.visible = true;
            this.rightArrow.visible = false;

            // this.game.isTutorial = false;
            // console.log('this.game.isTutorial: ', this.game.isTutorial);
            // this.tutorialIndex++
        }
    }

    private tutorialPanel: any;

    private initTutorialPanel() {
        this.tutorialPanel = this.children.getByName('TutorialPanel');
        this.tutorialPanel.title = this.tutorialPanel.getChildTextByName('TitleText');
        this.tutorialPanel.summary = this.tutorialPanel.getChildTextByName('SummaryText');
        this.tutorialPanel.readyButton = this.children.getByName('ReadyTutorialButton');

        this.tutorialPanel.hidePanel = () => {
            this.tutorialPanel.visible = false;
            this.tutorialPanel.title.visible = false;
            this.tutorialPanel.summary.visible = false;
            this.tutorialPanel.readyButton.visible = false;
        }

        this.tutorialPanel.showPanel = (showReadyButton: boolean = true, title: string = 'HOW TO PLAY', summary?: string) => {
            this.tutorialPanel.visible = true;
            this.tutorialPanel.title.visible = true;
            this.tutorialPanel.summary.visible = true;
            this.tutorialPanel.readyButton.visible = showReadyButton;
            this.screenInput = this.scene.scene.input.on("pointerdown", () => {
                // console.log("Start Tutorial!");

                if (this.tutorialPanel.readyButton.visible) {
                    this.game.events.emit('onReadyGo');
                    this.tutorialPanel.hidePanel();
                    this.bowlerPanel.resetOver();
                    this.currentBall = 0;
                    // this.bowlerPanel.showPanel();
                    this.pauseButton.visible = false;
                    this.screenInput.removeListener("pointerdown");
                }
            });

            this.tutorialPanel.title.text = title ? title : this.tutorialPanel.title.text;
            this.tutorialPanel.summary.text = summary ? summary : this.tutorialPanel.summary.text;
            this.bowlerPanel.hidePanel();
        }

        // this.tutorialPanel.readyButton.on('pointerdown', () => {

        // });
    }

    private onAwake() {
        this.currentBall = 0;

        this.currentOvers = 0;
        this.totalOvers = null;

        this.runs = 0;
        this.targetRuns = null;

        this.wickets = 0;
        this.totalWickets = null;

        this.duration = 0;
        this.totalDuration = null;
        this.tutorialIndex = 0;

        this.timerPanel.hidePanel();
        this.bowlerPanel.resetOver();
        this.pausePanel.hidePanel();
        this.scoreBoard.hidePanel();
        //this.tutorialPanel.hidePanel();
        this.watchAdPanel.hidePanel();
        this.hideControls();

        //this.bowlerPanel.showPanel();

        this.tweens.killAll();

    }

    private currentBall: number = 0;

    private onOutcome(outcome: OutcomeName) {
        this.currentBall++;

        switch (outcome) {
            case OutcomeName.LBW:
            case OutcomeName.Catch:
            case OutcomeName.Stumps:
                this.bowlerPanel['ball' + this.currentBall].text = 'W';
                break;

            case OutcomeName.None:
                this.bowlerPanel['ball' + this.currentBall].text = '.';
                break;

            default:
                this.bowlerPanel['ball' + this.currentBall].text = outcome;
                break;
        }

        this.bowlerPanel.oversText.text = "OVERS " + this.currentOvers + '.' + this.currentBall
            + (this.totalOvers != null ? '\t\t(' + this.totalOvers + ')' : '');

        if (this.currentBall % 6 == 0) {
            this.currentBall = 0;
            this.currentOvers++;
        }
        this.scoreBoard.showPanel(outcome)
        // this.delay(650, (() => { this.scoreBoard.showPanel(outcome) }).bind(this));
    }

    private currentOvers: number = 0;
    private totalOvers: number;

    private onOversChanged(overs: number, totalOvers?: number) {
        //this.currentOvers = overs;
        //this.totalOvers = totalOvers;

        /*this.bowlerPanel.oversText.text = "OVERS " + this.currentOvers + '.' + 0
            + (totalOvers != null ? '\t\t(' + totalOvers + ')' : '');*/
    }

    private runs: number = 0;
    private targetRuns: number;
    private onRunsChanged(runs: number, targetRuns?: number) {
        this.runs = runs;
        this.targetRuns = targetRuns;

        if (runs !== 0) {
            if (Game.gameState == GAME_STATE.GAME) {
                SDKManager.sendScore(runs);
                console.log("GAMESNACKS SCORE", runs);
            }
        }

        this.bowlerPanel.runsText.text = "RUNS " + this.runs
            + (targetRuns != null ? '\t(' + targetRuns + ')' : '');
    }

    private wickets: number = 0;
    private totalWickets: number;

    private onWicketsChanged(wickets: number, totalWickets?: number) {

        this.wickets = wickets;
        this.totalWickets = totalWickets;

        this.bowlerPanel.wicketsText.text = "WICKETS " + this.wickets
            + (totalWickets != null ? '\t(' + totalWickets + ')' : '');
    }

    private duration: number = 0;
    private totalDuration: number;

    private onDurationChanged(duration: number, totalDuration?: number) {
        this.timerPanel.showPanel();
        this.duration = duration;
        this.totalDuration = totalDuration;

        this.timerPanel.timerText.text = duration;
        if (duration <= 0) {
            this.timerPanel.hidePanel();
        }
    }
    private onGameOver(gameMessage: string, objectiveIndex?: number, rating: number = 3) {
        this.gameover = true;
        this.delay(1000, (() => {
            this.endPanel.showPanel(gameMessage, rating, objectiveIndex);
            if (gameMessage == "OBJECTIVE FAILED") {
                SDKManager.gameOver();
                //console.log("GAME over");
            }
            else {
                SDKManager.levelComplete(objectiveIndex + 1);
                //console.log("LEVEL NUMBER: ",objectiveIndex + 1);
            }
        }).bind(this));

        this.bowlerPanel.hidePanel();
        this.hideControls();
    }

    private onPlayStateChanged(playState: PlayState) {
        // console.log('playState: ', playState);
        switch (playState) {
            case PlayState.SetBowler:
                this.currentBall = 0;
                this.hideControls();
                break;

            case PlayState.Prepare:
                this.hideControls();
                break;

            case PlayState.Ready:
                if (!this.game.isTutorial)
                    this.showControls();
                break;

            case PlayState.BowlerRunning:
                if (!this.game.isTutorial)
                    this.showControls();
                break;

            case PlayState.Delivery:
                if (!this.game.isTutorial)
                    this.showControls();
                break;
        }
    }

    private onBowlerType(bowlerType: BallType) {
        if (this.game.isTutorial) {

            this.tutorialPanel.showPanel(true, "HOW TO PLAY", " Welcome to the game of cricket!");
            this.bowlerPanel.hidePanel();
        } else {
            this.currentBowlerPanel.showPanel(bowlerType);
            // this.delay(500, (() => { this.currentBowlerPanel.showPanel(bowlerType); }).bind(this));
        }
    }

    private currentBowlerPanel: any;

    private initCurrentBowlerPanel() {
        console.log("Bowler Panel")
        this.currentBowlerPanel = this.children.getByName('CurrentBowlerPanel') as UIImage;
        this.currentBowlerPanel.title = this.currentBowlerPanel.getChildTextByName('TitleText');
        //this.currentBowlerPanel.bowlerName = this.currentBowlerPanel.getChildTextByName('BowlerText');
        this.currentBowlerPanel.ballType = this.currentBowlerPanel.getChildTextByName('BallTypeText');

        this.currentBowlerPanel.handStraight = this.currentBowlerPanel.getChildImageByName('HandStraight');

        this.currentBowlerPanel.straightFast = this.currentBowlerPanel.getChildImageByName('StraightFast');
        this.currentBowlerPanel.straightMedium = this.currentBowlerPanel.getChildImageByName('StraightMedium');
        this.currentBowlerPanel.spinOffside = this.currentBowlerPanel.getChildImageByName('SpinOffside');
        this.currentBowlerPanel.spinLegside = this.currentBowlerPanel.getChildImageByName('SpinLegside');

        this.currentBowlerPanel.speedFast = this.currentBowlerPanel.getChildImageByName('SpeedFast');
        this.currentBowlerPanel.speedMedium = this.currentBowlerPanel.getChildImageByName('SpeedMedium');
        this.currentBowlerPanel.speedSlow = this.currentBowlerPanel.getChildImageByName('SpeedSlow');

        this.currentBowlerPanel.readyButton = this.children.getByName('ReadyButton') as UIImage;

        // this.currentBowlerPanel.readyButton.on('pointerdown', () => {
        // });

        // Hide Direction
        this.currentBowlerPanel.hideDirection = (() => {
            this.currentBowlerPanel.straightFast.visible = false;
            this.currentBowlerPanel.straightMedium.visible = false;
            this.currentBowlerPanel.spinOffside.visible = false;
            this.currentBowlerPanel.spinLegside.visible = false;
        }).bind(this.currentBowlerPanel);

        // Hide Speed
        this.currentBowlerPanel.hideSpeed = (() => {
            this.currentBowlerPanel.speedFast.visible = false;
            this.currentBowlerPanel.speedMedium.visible = false;
            this.currentBowlerPanel.speedSlow.visible = false;
        }).bind(this.currentBowlerPanel);

        // Hide Panel
        this.currentBowlerPanel.hidePanel = (() => {
            console.log("Hide Panel")
            this.currentBowlerPanel.title.visible = false;
            //this.currentBowlerPanel.bowlerName.visible = false;
            this.currentBowlerPanel.ballType.visible = false;

            this.currentBowlerPanel.hideDirection();
            this.currentBowlerPanel.hideSpeed();
            this.currentBowlerPanel.handStraight.visible = false;

            this.currentBowlerPanel.visible = false;
            this.currentBowlerPanel.readyButton.visible = false;

        }).bind(this.currentBowlerPanel);

        // Show Panel
        this.currentBowlerPanel.showPanel = ((bowlerType: BallType) => {
            this.currentBowlerPanel.hideDirection();
            this.currentBowlerPanel.hideSpeed();
            switch (bowlerType) {
                case BallType.Fast:
                    this.currentBowlerPanel.straightFast.visible = true;
                    this.currentBowlerPanel.speedFast.visible = true;
                    this.currentBowlerPanel.handStraight.visible = true;
                    this.currentBowlerPanel.ballType.text = "Straight Fast";
                    break;

                case BallType.Medium:
                    this.currentBowlerPanel.straightMedium.visible = true;
                    this.currentBowlerPanel.speedMedium.visible = true;
                    this.currentBowlerPanel.handStraight.visible = true;
                    this.currentBowlerPanel.ballType.text = "Straight Medium";
                    break;

                case BallType.Slow:
                    this.currentBowlerPanel.straightMedium.visible = true;
                    this.currentBowlerPanel.speedSlow.visible = true;
                    this.currentBowlerPanel.handStraight.visible = true;
                    this.currentBowlerPanel.ballType.text = "Straight Slow";
                    break;

                case BallType.LegSpin:
                    this.currentBowlerPanel.spinLegside.visible = true;
                    this.currentBowlerPanel.speedSlow.visible = true;
                    this.currentBowlerPanel.handStraight.visible = true;
                    this.currentBowlerPanel.ballType.text = "Leg Spin";
                    break;

                case BallType.OffSpin:
                    this.currentBowlerPanel.spinOffside.visible = true;
                    this.currentBowlerPanel.speedSlow.visible = true;
                    this.currentBowlerPanel.handStraight.visible = true;
                    this.currentBowlerPanel.ballType.text = "Off Spin";
                    break;
            }

            this.currentBowlerPanel.visible = true;
            this.currentBowlerPanel.title.visible = true;
            //this.currentBowlerPanel.bowlerName.visible = true;
            this.currentBowlerPanel.ballType.visible = true;
            this.currentBowlerPanel.readyButton.visible = true;
            // console.log('this.scene.scene.input: ', this.scene.scene.input);

            this.screenInput = this.scene.scene.input.on("pointerdown", () => {
                console.log("Start Game")
                this.canShowPausePanel = true;
                console.log("On Ready Go", this.canShowPausePanel)
                this.gameover = false;
                if (this.currentBowlerPanel.readyButton.visible) {
                    this.game.events.emit('onReadyGo');
                    this.currentBowlerPanel.hidePanel();
                    this.bowlerPanel.resetOver();
                    this.currentBall = 0;
                    //this.onOversChanged(this.currentOvers, this.totalOvers);
                    this.bowlerPanel.showPanel();
                    this.pauseButton.visible = true;
                    this.bowlerPanel.oversText.text = "OVERS " + this.currentOvers + '.' + this.currentBall
                        + (this.totalOvers != null ? '\t\t(' + this.totalOvers + ')' : '');

                    this.screenInput.removeListener("pointerdown");
                }
            });


            this.bowlerPanel.ballType.text = this.currentBowlerPanel.ballType.text;
            this.pauseButton.visible = false;
        }).bind(this.currentBowlerPanel);
    }

    private leftArrow: UIImage;
    private rightArrow: UIImage;
    private hitAreaMulti: number = 150;

    private rightKey: Phaser.Input.Keyboard.Key

    private initControls() {
        this.leftArrow = this.children.getByName('LeftButton-pc') as UIImage;
        this.rightArrow = this.children.getByName('RightButton-pc') as UIImage;

        let isMobile = this.sys.game.device.os.android || this.sys.game.device.os.iOS || this.sys.game.device.os.iPad;

        if (isMobile) {
            this.leftArrow.setTexture("game-ui", "left-button.png");
            this.rightArrow.setTexture("game-ui", "right-button.png");
        }

        this.input.keyboard.on('keydown-LEFT', this.leftInput, this);
        this.input.keyboard.on('keydown-RIGHT', this.rightInput, this);
        this.leftArrow.on('pointerdown', this.leftInput, this);
        this.rightArrow.on('pointerdown', this.rightInput, this);

        // if(this.sys.game.device.os.desktop){
        // }
        // else{
        // }
        // this.leftArrow.on('pointerdown', (() => {
        //     this.game.events.emit('onLeftArrow');
        //     if (this.tutorialIndex == 2) {
        //         this.bowlerPanel.showPanel();
        //     }
        //     this.tutorialPanel.hidePanel();

        // }).bind(this));

        // this.rightArrow.on('pointerdown', (() => {
        //     this.game.events.emit('onRightArrow');
        //     this.tutorialPanel.hidePanel();
        // }).bind(this));


        this.leftArrow.input.hitArea.setTo(-this.hitAreaMulti, -this.hitAreaMulti, this.leftArrow.width + this.hitAreaMulti * 2, this.leftArrow.height + this.hitAreaMulti * 2);
        this.rightArrow.input.hitArea.setTo(-this.hitAreaMulti / 2, -this.hitAreaMulti, this.rightArrow.width + this.hitAreaMulti * 2, this.rightArrow.height + this.hitAreaMulti * 2);
        // this.input.enableDebug(this.leftArrow);
        // this.input.enableDebug(this.rightArrow);
    }

    private leftInput() {
        if (InGameHUD.inputEnabled) {
            this.game.events.emit('onLeftArrow');
            if (this.game.isTutorial && InGameHUD.inputType == "LEFT") {
                // console.log('leftInput: ', this.tutorialIndex , this.game.isTutorial , InGameHUD.inputType);
                this.tutorialPanel.hidePanel();
                this.bowlerPanel.showPanel();
                this.tutorialIndex = 0;
                this.game.isTutorial = false;
                InGameHUD.inputType = "";

            }
        }
    }

    private rightInput() {

        if (InGameHUD.inputEnabled) {
            // console.log('rightInput: ', this.tutorialIndex ,this.game.isTutorial , InGameHUD.inputType);
            this.game.events.emit('onRightArrow');
            if (this.game.isTutorial && InGameHUD.inputType == "RIGHT") {
                this.tutorialIndex++
            }

        }
        if (this.tutorialIndex == 1) {
            this.tutorialPanel.hidePanel();
        }
    }


    private hideControls() {
        this.leftArrow.visible = false;
        this.rightArrow.visible = false;
    }

    private showControls() {
        this.leftArrow.visible = true;
        this.rightArrow.visible = true;
    }

    private bowlerPanel: any;

    private initBowlerPanel() {
        this.bowlerPanel = this.children.getByName('BowlerPanel') as UIImage;
        this.bowlerPanel.runsText = this.bowlerPanel.getChildTextByName('RunsText');
        this.bowlerPanel.oversText = this.bowlerPanel.getChildTextByName('OversText');
        this.bowlerPanel.wicketsText = this.bowlerPanel.getChildTextByName('WicketsText');

        for (let i = 1; i <= 6; i++) {
            var name = 'ball' + i;
            this.bowlerPanel[name] = this.bowlerPanel.getChildTextByName('Ball (' + i + ')');
        }

        this.bowlerPanel.ballType = this.bowlerPanel.getChildTextByName('BallTypeText');
        this.bowlerPanel.pauseButton = this.bowlerPanel.getChildImageByName('PauseButton');
        this.pauseButton = this.bowlerPanel.pauseButton;

        this.bowlerPanel.pauseButton.on('pointerdown', () => {
            this.game.events.emit('onPauseButton');
            this.bowlerPanel.hidePanel();
            this.hideControls();
            this.pausePanel.showPanel();
        });

        this.bowlerPanel.resetOver = () => {
            for (let i = 1; i <= 6; i++) {
                var name = 'ball' + i;
                this.bowlerPanel[name].text = '';
            }
        };

        this.bowlerPanel.hidePanel = () => {
            this.bowlerPanel.runsText.visible = false;
            this.bowlerPanel.oversText.visible = false;
            this.bowlerPanel.wicketsText.visible = false;

            for (let i = 1; i <= 6; i++) {
                var name = 'ball' + i;
                this.bowlerPanel[name].visible = false;
            }

            this.bowlerPanel.ballType.visible = false;
            this.bowlerPanel.pauseButton.visible = false;
            this.bowlerPanel.visible = false;
        };

        this.bowlerPanel.showPanel = () => {
            this.bowlerPanel.runsText.visible = true;
            this.bowlerPanel.oversText.visible = true;
            this.bowlerPanel.wicketsText.visible = true;

            for (let i = 1; i <= 6; i++) {
                var name = 'ball' + i;
                this.bowlerPanel[name].visible = true;
            }


            this.bowlerPanel.ballType.visible = true;
            this.bowlerPanel.pauseButton.visible = true;
            this.bowlerPanel.visible = true;

        };
        this.bowlerPanel.hidePanel();
    }

    private timerPanel: any;

    private initTimerPanel() {
        this.timerPanel = this.children.getByName('TimerPanel');
        this.timerPanel.timerText = this.timerPanel.getChildTextByName('TimerText');
        this.timerPanel.hidePanel = (() => {
            this.timerPanel.timerText.visible = false;
            this.timerPanel.visible = false;
            // //console.log("TIMER PANEL IS HIDDEN");
        }).bind(this.timerPanel);

        this.timerPanel.showPanel = (() => {
            this.timerPanel.timerText.visible = true;
            this.timerPanel.visible = true;
            // //console.log("TIMER PANEL IS SHOWN");
        }).bind(this.timerPanel);
    }

    private watchAdPanel: any;

    private initWatchAdPanel() {
        this.watchAdPanel = this.children.getByName('WatchAdPanel');
        this.watchAdPanel.dullBackground = this.children.getByName('DullBackground');

        this.watchAdPanel.timerMask = this.add.graphics();
        this.watchAdPanel.timerBG = this.watchAdPanel.getChildImageByName('TimerBG');
        this.watchAdPanel.timerFill = this.watchAdPanel.getChildImageByName('TimerFill');
        this.watchAdPanel.watchAdButton = this.watchAdPanel.getChildImageByName('WatchAdButton');

        this.watchAdPanel.timerFill.mask = new Phaser.Display.Masks.BitmapMask(this, this.watchAdPanel.timerMask);

        this.watchAdPanel.watchAdText = this.watchAdPanel.getChildTextByName('WatchAdText');
        this.watchAdPanel.secondsText = this.watchAdPanel.getChildTextByName('SecondsText');

        this.watchAdPanel.hidePanel = (() => {
            this.watchAdPanel.visible = false;
            this.watchAdPanel.dullBackground.visible = false;

            this.watchAdPanel.timerBG.visible = false;
            this.watchAdPanel.timerFill.visible = false;
            this.watchAdPanel.watchAdButton.visible = false;

            this.watchAdPanel.watchAdText.visible = false;
            this.watchAdPanel.secondsText.visible = false;
            this.watchAdPanel.timerMask.visible = false;
        }).bind(this);

        this.watchAdPanel.showPanel = (() => {
            this.watchAdPanel.visible = true;
            this.watchAdPanel.dullBackground.visible = true;

            this.watchAdPanel.timerBG.visible = true;
            this.watchAdPanel.timerFill.visible = true;
            this.watchAdPanel.timerMask.visible = true;
            this.watchAdPanel.watchAdButton.visible = true;

            this.watchAdPanel.watchAdText.visible = true;
            this.watchAdPanel.secondsText.visible = true;

            if (this.watchAdPanel.timerCounter != null) {
                this.watchAdPanel.timerCounter.stop();
                //this.watchAdPanel.timerCounter.kill();
            }
            this.onConsoleTextChanged('showing text');
            this.watchAdPanel.timerCounter = this.tweens.addCounter({
                from: 0,
                to: 360,
                duration: 5000,
                ease: 'Linear',
                delay: 0,
                onStart: () => {
                    this.watchAdPanel.secondsText.text = '5';
                },
                onUpdate: (tween) => {
                    this.watchAdPanel.timerMask.setDepth(this.watchAdPanel.timerFill.depth - 1);
                    this.watchAdPanel.timerMask.setScale(this.watchAdPanel.timerFill.scale);
                    this.watchAdPanel.timerMask.setPosition(this.watchAdPanel.timerFill.x, this.watchAdPanel.timerFill.y);
                    this.watchAdPanel.timerMask.clear();
                    this.watchAdPanel.timerMask.lineStyle(40, 0, 1);
                    this.watchAdPanel.timerMask.beginPath();
                    this.watchAdPanel.timerMask.arc(0, 0, 100, 0, Phaser.Math.DegToRad(tween.getValue()), false);
                    this.watchAdPanel.timerMask.strokePath();
                    this.watchAdPanel.timerMask.closePath();
                    this.watchAdPanel.timerMask.setAngle(-90);
                    this.watchAdPanel.secondsText.text = `${Phaser.Math.Clamp((Math.round(tween.duration - tween.totalElapsed) / 1000), 0, 5).toFixed()}`
                },
                onComplete: () => {
                    this.watchRewardAd(1);
                    // this.onConsoleTextChanged('call game over cause its done');
                    // this.watchAdPanel.hidePanel();
                    // this.game.events.emit(Events.OnAdWatched, false);
                }
            });
        }).bind(this);

        this.watchAdPanel.watchAdButton.on('pointerdown', (() => {
            this.watchRewardAd(0);
        }).bind(this))
    }

    private watchRewardAd(autoPlayed: number) {
        if (this.watchAdPanel.timerCounter != null) {
            this.watchAdPanel.timerCounter.stop();
            //this.tweens.killTweensOf (this.watchAdPanel.timerCounter);
        }
        this.watchAdPanel.hidePanel();
    }

    private endPanel: any;

    private initEndPanel() {
        this.endPanel = this.children.getByName('EndPanel');

        for (let i = 1; i <= 3; i++) {
            var name = 'stumps' + i;
            this.endPanel[name] = this.endPanel.getChildImageByName('Stumps (' + i + ')');
        }

        this.endPanel.stumpsGround = this.endPanel.getChildImageByName('StumpsGround');
        this.endPanel.bigGloves = this.endPanel.getChildImageByName('BigGloves');
        this.endPanel.messageText = this.endPanel.getChildTextByName('MessageText');
        this.endPanel.playButton = this.children.getByName('PlayButton');
        this.endPanel.restartButton = this.children.getByName('RestartButton');
        this.endPanel.dullBackground = this.children.getByName('DullBackground');


        this.endPanel.playButton.on('pointerdown', () => {
            Game.gameState = GAME_STATE.MAIN_MENU;
            // this.game.events.emit(Events.OnCompletedContinue);
            // this.endPanel.hidePanel();
        });

        this.endPanel.restartButton.on('pointerdown', () => {
            this.game.events.emit(Events.OnRestart);
            this.onAwake();
            this.endPanel.hidePanel();
        });

        this.endPanel.hidePanel = (() => {
            this.endPanel.visible = false;
            this.endPanel.stumps1.visible = false;
            this.endPanel.stumps2.visible = false;
            this.endPanel.stumps3.visible = false;
            this.endPanel.stumpsGround.visible = false;
            this.endPanel.bigGloves.visible = false;
            this.endPanel.messageText.visible = false;
            this.endPanel.playButton.visible = false;
            this.endPanel.restartButton.visible = false;
            this.endPanel.dullBackground.visible = false;

        }).bind(this.endPanel);


        this.endPanel.showPanel = ((message: string, rating: number, objectiveIndex?: number) => {
            this.endPanel.stumpsGround.visible = true;
            this.endPanel.messageText.visible = true;

            this.endPanel.messageText.text = message;
            this.endPanel.playButton.visible = objectiveIndex == -1 ? false : true;

            if (objectiveIndex > 0) {

            }

            setTimeout(() => {
                if (objectiveIndex > -1) {
                    this.screenInput = this.scene.scene.input.on("pointerdown", () => {
                        this.game.events.emit(Events.OnCompletedContinue);
                        this.endPanel.hidePanel();
                        this.screenInput.removeListener("pointerdown");
                    });
                }
            }, 200);

            this.endPanel.restartButton.visible = false;

            this.endPanel.visible = (rating == 3);
            for (let i = 1; i <= rating; i++) {
                var targetPosition = this.endPanel['stumps' + i].y;
                if (i == 3) {

                    this.tweens.addCounter({
                        from: 0,
                        to: 1,
                        duration: 1000,
                        ease: 'Bounce.Out',
                        delay: (i * 200) + 800,
                        onStart: () => {
                            this.endPanel.bigGloves.setScaleFactor(0);
                            this.endPanel.bigGloves.visible = true;
                        },
                        onUpdate: (tween) => {
                            this.endPanel.bigGloves.setScaleFactor(tween.getValue());
                        }
                    })
                } else {

                }
                this.endPanel['stumps' + i].visible = true;
                this.endPanel['stumps' + i].y = -1000;
                this.tweens.addCounter({
                    to: targetPosition,
                    duration: 300,
                    ease: 'Expo',
                    delay: i * 200,
                    onUpdate: (tween) => {
                        this.endPanel[`stumps${i}`].setY((tween.getValue()));
                    }
                })
            }

            this.endPanel.dullBackground.visible = true;
            this.pauseButton.visible = false;

        }).bind(this.endPanel);
    }

    update() {
        this.endPanel.angle += 0.5;
    }

    public pausePanel: any;
    private pauseButton: UIImage;

    private initPausePanel() {
        this.pausePanel = this.children.getByName('PausePanel');
        this.pausePanel.title = this.pausePanel.getChildImageByName('PauseTitle');
        this.pausePanel.resumeButton = this.pausePanel.getChildImageByName('ResumeButton');
        this.pausePanel.replayButton = this.pausePanel.getChildImageByName('ReplayButton');
        this.pausePanel.soundButton = this.pausePanel.getChildImageByName('SoundButton') as UIImage;
        this.pausePanel.exitButton = this.pausePanel.getChildImageByName('ExitButton');
        this.pausePanel.dullBackground = this.children.getByName('DullBackground');

        this.pausePanel.hidePanel = (() => {
            this.pausePanel.title.visible = false;
            this.pausePanel.resumeButton.visible = false;
            this.pausePanel.replayButton.visible = false;
            this.pausePanel.soundButton.visible = false;
            this.pausePanel.exitButton.visible = false;
            this.pausePanel.dullBackground.visible = false;
        });

        this.pausePanel.showPanel = (() => {
            this.pausePanel.title.visible = true;
            this.pausePanel.resumeButton.visible = true;
            this.pausePanel.replayButton.visible = true;
            this.pausePanel.soundButton.visible = false;
            this.pausePanel.exitButton.visible = true;
            this.pausePanel.dullBackground.visible = true;


        });

        this.pausePanel.resumeButton.on('pointerdown', () => {
            this.game.events.emit('onResumeButton');
            this.pausePanel.hidePanel();
            this.bowlerPanel.showPanel();
            this.showControls();
        });

        this.pausePanel.replayButton.on('pointerdown', () => {
            SDKManager.gameOver();
            //console.log("GAME OVER");
            this.game.events.emit('onResumeButton');
            this.game.events.emit(Events.OnRestart);
            this.onAwake();
            this.endPanel.hidePanel();
        });

        this.pausePanel.soundButton.on('pointerdown', () => {
            App.isMute = this.game.sound.mute = !this.game.sound.mute
            this.pausePanel.soundButton.setTexture('game-ui', this.game.sound.mute ? 'sound-off-button.png' : 'sound-on-button.png');
        });

        this.pausePanel.exitButton.on('pointerdown', () => {
            this.canShowPausePanel = false;
            console.log("Pause panel close", this.canShowPausePanel)
            SDKManager.gameOver();
            console.log("Interstitial Ad")
            SDKManager.interstitialAdCallback(
                "next", "interstitial",
                this.beforeAd.bind(this), this.afterAd.bind(this),
                this.adBreakDone.bind(this));
            Game.gameState = GAME_STATE.MAIN_MENU;
            // console.log("GAME OVER");
            this.game.events.emit(Events.OnCompletedContinue);
            this.endPanel.hidePanel();
            this.screenInput.removeListener('pointerdown')
        })
    }

    public beforeAd() {
        App.isMute = this.game.sound.mute = true;
    }

    public afterAd() {
        Game.instance.checkAudioAfterAd();
    }

    adBreakDone(placementInfo: any) {
        console.log("placement info", placementInfo);

    }

    private scoreBoard: any;

    private initScoreBoard() {
        this.scoreBoard = this.children.getByName('ScoreBoard');
        this.scoreBoard.score1 = this.scoreBoard.getChildImageByName('Score (1)');
        this.scoreBoard.score2 = this.scoreBoard.getChildImageByName('Score (2)');
        this.scoreBoard.score3 = this.scoreBoard.getChildImageByName('Score (3)');
        this.scoreBoard.score4 = this.scoreBoard.getChildImageByName('Score (4)');
        this.scoreBoard.score6 = this.scoreBoard.getChildImageByName('Score (6)');

        this.scoreBoard.out1 = this.scoreBoard.getChildImageByName('Out (-1)');
        this.scoreBoard.out2 = this.scoreBoard.getChildImageByName('Out (-2)');
        this.scoreBoard.out3 = this.scoreBoard.getChildImageByName('Out (-3)');

        this.scoreBoard.hidePanel = () => {
            this.scoreBoard.visible = false;
            for (let i = 1; i <= 6; i++) {
                if (this.scoreBoard[`score${i}`]) {
                    this.scoreBoard[`score${i}`].visible = false;
                }
            }

            for (let i = 1; i <= 3; i++) {
                if (this.scoreBoard[`out${i}`]) {
                    this.scoreBoard[`out${i}`].visible = false;
                }
            }
        }

        this.scoreBoard.showPanel = (score: number) => {
            //console.log('Scoreboard: ' + score);
            if (score > 0) {
                this.scoreBoard.visible = score > 3;

                for (let i = 1; i <= 6; i++) {
                    if (this.scoreBoard[`score${i}`]) {
                        this.scoreBoard[`score${i}`].visible = (i == score);
                    }
                }

                for (let i = 1; i <= 3; i++) {
                    if (this.scoreBoard[`out${i}`]) {
                        this.scoreBoard[`out${i}`].visible = false;
                    }
                }
            } else {
                this.scoreBoard.visible = false;
                for (let i = 1; i <= 6; i++) {
                    if (this.scoreBoard[`score${i}`]) {
                        this.scoreBoard[`score${i}`].visible = false;
                    }
                }

                for (let i = 1; i <= 3; i++) {
                    if (this.scoreBoard[`out${i}`]) {
                        this.scoreBoard[`out${i}`].visible = (i == -1 * score);
                    }
                }
            }

            var image: UIImage;

            this.tweens.addCounter({
                from: 0,
                to: 1,
                duration: 350,
                ease: 'Back',
                yoyo: true,
                hold: 800,
                onUpdate: (tween) => {
                    this.scoreBoard.setScaleFactor(tween.getValue());
                }
            })
        }
    }



    private delay(duration: number = 500, method: () => void) {
        this.tweens.addCounter({
            from: 0,
            to: 1,
            duration: duration,
            ease: 'Linear',
            onComplete: method
        });
    }


}